export default [
    {
        path: '/volunteerPage',
        name: 'volunteerPage',
        component: () => import('../views/volunteer/volunteerHome.vue'),
        meta: {
            title: '志愿者报名'
        }
    },
    {
        path: '/volunteerDetail',
        name: 'volunteerDetail',
        component: () => import('../views/volunteer/volunteerDetailPage.vue'),
        meta: {
            title: '志愿者活动详情'
        }
    },
    {
        path: '/fillVolunteerInfo',
        name: 'fillVolunteerInfo',
        component: () => import('../views/volunteer/fillVolunteerInfo.vue'),
        meta: {
            title: '志愿者报名',
        }
    },
    {
        path: '/volunteerSuccess',
        name: 'volunteerSuccess',
        component: () => import('../views/volunteer/volunteerSuccessPage.vue'),
    },

    {
        path: '/fillApplyVolunteerInfo',
        name: 'fillApplyVolunteerInfo',
        component: () => import('../views/volunteer/fillApplyVolunteerInfo.vue'),
        meta: {
            title: '志愿者申请'
        }
    },
    {
        path: '/applyVolunteerSuccess',
        name: 'applyVolunteerSuccess',
        component: () => import('../views/volunteer/applyVolunteerSuccessPage.vue'),
    },
    //
    {
        path: "/VolunteerProgress",
        name: "VolunteerProgress",
        component: () => import('../views/volunteer/VolunteerProgress.vue'),
        meta: {
            title: "志愿者申请进度"
        }
    },
];
